import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OptionComponent } from '../abstract/option.component';
import { optionNumberMinValidator } from './option-number-min-validator.fn';
import { optionNumberDuplicateValidator } from './option-number-dulicate-validator.fn'; 

@Component({
  selector: 'option-number',
  styleUrls: ['./option-number.component.css'], 
  templateUrl: './option-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class OptionNumberComponent extends OptionComponent {

  ngOnInit () {
    super.ngOnInit();
    if (this.text) this.text.control.setValidators(
      [optionNumberMinValidator(this.option), optionNumberDuplicateValidator(this.option)]
    );
    this.subscriptions.push(this.option.question.getChildTracker(['options']).onContentUpdate.subscribe(()=>{
      this.refreshView();
    }));    
    this.subscriptions.push(this.option.question.getChildTracker(['canHaveQuotaOptions']).onContentUpdate.subscribe(()=>{
      this.refreshView();
    }));    

  }

  refreshView() {
    if (this.text) this.text.control.updateValueAndValidity();
    super.refreshView();
  }
  // onFocus ($event:MouseEvent) {
  //   (<HTMLTextAreaElement>$event.target).click();
  // }
}
